import { cssColorValue, cssSpacing } from "../../styles/index.mjs";
import { Svg } from "../Icon/Svg.mjs";
import styled, { css } from "../../styled-components.mjs";
export var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-15slb3k-0"
})(["", ""], function (_ref) {
  var $align = _ref.$align,
    $semanticColor = _ref.$semanticColor,
    $spacer = _ref.$spacer;
  return css(["display:inline-flex;align-items:center;flex-direction:", ";", " ", "{flex-shrink:0;", " ", "}"], $align === 'end' ? undefined : 'row-reverse', $semanticColor && css(["color:", ";"], cssColorValue($semanticColor)), Svg, $align === 'start' && css(["margin-inline-end:", ";"], $spacer || cssSpacing('base', '16px')), $align === 'end' && css(["margin-inline-start:", ";"], $spacer || cssSpacing('base', '16px')));
});